







export default {
  props: {
    title: {
      type: String,
      default: '',
      required: false,
    },
  },
};
